module.exports = {"width":375,"height":370,"type":"png"}